import { render } from "./AccountCompletionType.vue?vue&type=template&id=18ff5284&scoped=true"
const script = {}

import "./AccountCompletionType.vue?vue&type=style&index=0&id=18ff5284&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18ff5284"]])

export default __exports__